function CollapseDetails({ object, onDelete, onEdit, onConfirm, isAdmin }) {
  const suppliersAddress = `${object?.supplier?.region}, ${
    object?.supplier?.province || ""
  }, ${object?.supplier?.city}, ${object?.supplier?.barangay}`;

  return (
    <div className="d-flex flex-column gap-1 p-2">
      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">TIN :</label>
        <p className="m-0">{object?.supplier?.tinNo || "N/A"}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">VAT Value :</label>
        <p className="m-0"> &#8369; {object?.vat}</p>
      </div>

      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">Net Value :</label>
        <p className="m-0"> &#8369; {object?.net}</p>
      </div>

      <div className="d-flex gap-2 mt-2">
        <button
          className="btn text-center text-white fw-medium bg-primary"
          onClick={() => onEdit(object)}
        >
          <i
            className={`${isAdmin || object?.status === "audited" ? "bi bi-eye" : "bi bi-pencil"} me-2`}
          ></i>
          {isAdmin ||
          object?.status === "audited" ||
          object?.status === "for_audit"
            ? "View"
            : "Edit"}
        </button>

        {isAdmin && object?.status === "for_audit" && (
          <button
            className="btn text-center text-white bg-success fw-medium"
            onClick={() => onConfirm(object)}
          >
            <i className="bi bi-check2 me-2"></i>
            Confirm Audit
          </button>
        )}

        {/* {!isAdmin && (
          <button
            className="btn btn-danger text-center bg-danger fw-medium"
            onClick={() => onDelete(object.id)}
          >
            <i className="bi bi-trash me-2"></i>
            Delete
          </button>
        )} */}
      </div>
    </div>
  );
}

export default CollapseDetails;
